// https://github.com/BrooonS/timezz

import {timezz} from 'timezz';

const el = '.js-countdown'

if (document.querySelector(el)) {
  timezz(document.querySelector(el), {
    date: new Date('May 26, 2023 16:00:00')
  })
}
